import SwipeableShorts from "./SwipableShorts";
import FilterTabs from "./Filters";
import { useLocation, useNavigate } from "react-router-dom";
import backIcon from "../../../assets/images/arrow-left.svg";

const CommonLayout = ({
  showTabsBar,
  activeTab,
  handleShortClick,
  children,
  setActiveTab,
}: any) => {
  const { state } = useLocation();
  const { currentShot, tag } = state || {};
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-col items-center relative">
      {/* FilterTabs as an overlay */}
      {showTabsBar && !["topicNews", "shotTags"].includes(activeTab) && (
        <div className="absolute top-0 z-20 w-full max-w-screen-md bg-white">
          <FilterTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      )}

      {showTabsBar && ["topicNews", "shotTags"].includes(activeTab) && (
        <div className="absolute top-0 z-20 w-full bg-white">
          <div className="flex gap-1.5 items-center px-4 py-4 text-base font-semibold tracking-tight text-center bg-white border-b border-solid border-b-zinc-200 text-zinc-900">
            <img
              loading="lazy"
              src={backIcon}
              className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
              onClick={() => navigate(-1)}
            />
            <div className="self-stretch my-auto">
              {activeTab === "topicNews"
                ? tag?.speciality?.[0].code || tag?.code
                : tag?.tagName}
            </div>
          </div>
        </div>
      )}

      {/* Main content */}
      <div
        className="w-full max-w-screen-md relative z-10"
        onClick={handleShortClick}
      >
        <SwipeableShorts
          currentShot={currentShot}
          type={activeTab}
          setActiveTab={setActiveTab}
          topic={tag?.speciality?.[0].code || tag?.code}
        />
      </div>

      <div className="w-full max-w-screen-md">{children}</div>
    </div>
  );
};

export default CommonLayout;
